<template>
  <div class="room-live-slider">
    <div id="txtslidesuite">
      <div class="separator" :style="{background: color}"></div>
      <h2>{{name}}</h2>
      <em :style="{background: color}">{{area}}m<sup>2</sup></em>
      <p>{{inlineAddress}}</p>
      <p v-if="label"><span class="fg-primary imp">{{label}}</span></p>
    </div>
    <RoomHeaderPictures />
  </div>
</template>

<script>
  import RoomHeaderPictures from "./RoomHeaderPictures";
  export default {
    name: 'RoomHeaderSlider',
    components: {RoomHeaderPictures},
    props: ['name', 'color', 'area', 'inlineAddress', 'prev', 'next', 'label'],
    data() {
      return {};
    },
    methods: {
    },
  };
</script>

<style scoped>
  .separator {
    top: 0;
    height: 1px;
    width: 80px;
    margin: 0 0 0 -40px;
    left: 50%;
    content: '';
    z-index: 5;
    position: absolute;
  }

  .slider_image:not(.loaded) {
    opacity: 0;
  }
  .imp {
    font-size: 26px;
    text-transform: uppercase;
  }
  @media (max-width: 550px) {
    .imp {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/rooms/components/RoomHeaderSlider.vue